/**
 * PARTSBOOK Vehicle Selector & Fitment Engine
 * Allows customers to filter catalog by Year, Make, Model, Engine
 * Persists selection in localStorage
 */

document.addEventListener('DOMContentLoaded', () => {
  const vehicleDatabase = {
    "Nissan": {
      "Qashqai": {
        "2014-2021 (J11)": ["1.2 DIG-T (HRA2DDT)", "1.5 dCi (K9K)", "1.6 DIG-T (MR16DDT)", "2.0 Petrol (MR20)"],
        "2007-2013 (J10)": ["1.5 dCi", "1.6 Petrol (HR16DE)", "2.0 dCi (M9R)", "2.0 Petrol (MR20DE)"]
      },
      "X-Trail": {
        "2014-2022 (T32)": ["1.6 dCi", "1.7 dCi", "2.0 dCi (M9R)", "2.0 Petrol (MR20)"]
      },
      "Navara": {
        "2015-2023 (D23)": ["2.3 dCi (YS23DDT / YS23DDTT)"],
        "2005-2015 (D40)": ["2.5 dCi (YD25DDTi)", "3.0 dCi V6 (V9X)"]
      }
    },
    "Toyota": {
      "RAV4": {
        "2013-2018 (XA40)": ["2.0 D-4D", "2.0 Valvematic (3ZR-FAE)", "2.5 Hybrid (2AR-FXE)"],
        "2006-2012 (XA30)": ["2.0 VVT-i (1AZ-FE)", "2.2 D-4D (2AD-FTV)", "2.2 D-CAT (2AD-FHV)"]
      },
      "Avensis": {
        "2009-2018 (T27)": ["1.8 Valvematic (2ZR-FAE)", "2.0 Valvematic (3ZR-FAE)", "2.0 D-4D (1AD-FTV)"]
      },
      "Hilux": {
        "2015-2023 (AN120)": ["2.4 D-4D (2GD-FTV)", "2.8 D-4D (1GD-FTV)"],
        "2005-2015 (KUN25/26)": ["2.5 D-4D (2KD-FTV)", "3.0 D-4D (1KD-FTV)"]
      }
    },
    "Jaguar": {
      "X-Type": {
        "2001-2009": ["2.0 V6 Petrol", "2.0d Diesel (Duratorq)", "2.2d Diesel (Duratorq)", "2.5 V6 Petrol", "3.0 V6 Petrol"]
      },
      "XF": {
        "2008-2015 (X250)": ["2.2d (AJ-i4D)", "2.7d V6", "3.0d V6 (AJ-V6D)", "3.0 V6 Petrol"]
      }
    },
    "Holden / Chevrolet": {
      "Colorado": {
        "2012-2020 (RG)": ["2.8L Duramax Diesel (LWN / LWH)", "2.5L Duramax Diesel"]
      }
    },
    "Volkswagen": {
      "Golf": {
        "2012-2020 (MK7)": ["1.4 TSI", "1.6 TDI", "2.0 TDI", "2.0 TSI GTI/R (EA888 Gen3)"]
      },
      "Beetle / Jetta": {
        "2011-2019": ["1.8T Gen3 (06K-145-701-R)", "2.0 TSI"]
      }
    },
    "Mazda": {
      "CX-5": {
        "2012-2017 (KE)": ["2.2 SkyActiv-D (SH-VPTS)", "2.0 SkyActiv-G"],
        "2017-2023 (KF)": ["2.2 SkyActiv-D", "2.0 SkyActiv-G", "2.5 SkyActiv-G"]
      }
    },
    "Mitsubishi": {
      "L200": {
        "2015-2023 (Series 5/6)": ["2.4 DI-D (4N15)", "2.2 DI-D (4N14)"],
        "2006-2015 (Series 4)": ["2.5 DI-D (4D56)"]
      },
      "Outlander": {
        "2012-2021 (MK3)": ["2.0 MIVEC", "2.0 PHEV (4B11)", "2.2 DI-D (4N14)"]
      }
    }
  };

  const makeSelect = document.getElementById('vehicle-make-select');
  const modelSelect = document.getElementById('vehicle-model-select');
  const yearSelect = document.getElementById('vehicle-year-select');
  const engineSelect = document.getElementById('vehicle-engine-select');
  const submitBtn = document.getElementById('vehicle-find-parts-btn');
  const resetBtn = document.getElementById('vehicle-reset-btn');
  const currentVehicleBadge = document.getElementById('current-vehicle-badge');

  // Load saved vehicle
  let savedVehicle = null;
  try { savedVehicle = JSON.parse(localStorage.getItem('partsbook_selected_vehicle') || 'null'); } catch {}
  const escapeText = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  if (savedVehicle && currentVehicleBadge) {
    currentVehicleBadge.innerHTML = `
      <div style="background:#16a34a; color:#fff; padding:6px 12px; border-radius:4px; font-size:12px; font-weight:700; display:inline-flex; align-items:center; gap:6px;">
        <span>Search selection: ${escapeText(savedVehicle.year)} ${escapeText(savedVehicle.make)} ${escapeText(savedVehicle.model)} (${escapeText(savedVehicle.engine)})</span>
        <button id="clear-saved-vehicle" style="background:none; border:none; color:#fff; cursor:pointer; font-weight:bold;">✕</button>
      </div>
    `;
    document.getElementById('clear-saved-vehicle')?.addEventListener('click', () => {
      try { localStorage.removeItem('partsbook_selected_vehicle'); } catch {}
      window.location.reload();
    });
  }

  if (!makeSelect) return;
  resetBtn?.addEventListener('click', () => {
    makeSelect.value='';
    [modelSelect,yearSelect,engineSelect].forEach(select => { select.selectedIndex=0; select.disabled=true; });
    try { localStorage.removeItem('partsbook_selected_vehicle'); } catch {}
    if(currentVehicleBadge) currentVehicleBadge.replaceChildren();
  });

  // Populate Makes
  Object.keys(vehicleDatabase).forEach(make => {
    const opt = document.createElement('option');
    opt.value = make;
    opt.textContent = make;
    makeSelect.appendChild(opt);
  });

  makeSelect.addEventListener('change', () => {
    const make = makeSelect.value;
    modelSelect.innerHTML = '<option value="">2. Select Model</option>';
    yearSelect.innerHTML = '<option value="">3. Select Year / Series</option>';
    engineSelect.innerHTML = '<option value="">4. Select Engine / Code</option>';
    modelSelect.disabled = !make;
    yearSelect.disabled = true;
    engineSelect.disabled = true;

    if (make && vehicleDatabase[make]) {
      Object.keys(vehicleDatabase[make]).forEach(model => {
        const opt = document.createElement('option');
        opt.value = model;
        opt.textContent = model;
        modelSelect.appendChild(opt);
      });
    }
  });

  modelSelect.addEventListener('change', () => {
    const make = makeSelect.value;
    const model = modelSelect.value;
    yearSelect.innerHTML = '<option value="">3. Select Year / Series</option>';
    engineSelect.innerHTML = '<option value="">4. Select Engine / Code</option>';
    yearSelect.disabled = !model;
    engineSelect.disabled = true;

    if (make && model && vehicleDatabase[make][model]) {
      Object.keys(vehicleDatabase[make][model]).forEach(year => {
        const opt = document.createElement('option');
        opt.value = year;
        opt.textContent = year;
        yearSelect.appendChild(opt);
      });
    }
  });

  yearSelect.addEventListener('change', () => {
    const make = makeSelect.value;
    const model = modelSelect.value;
    const year = yearSelect.value;
    engineSelect.innerHTML = '<option value="">4. Select Engine / Code</option>';
    engineSelect.disabled = !year;

    if (make && model && year && vehicleDatabase[make][model][year]) {
      vehicleDatabase[make][model][year].forEach(engine => {
        const opt = document.createElement('option');
        opt.value = engine;
        opt.textContent = engine;
        engineSelect.appendChild(opt);
      });
    }
  });

  submitBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    const make = makeSelect.value;
    const model = modelSelect.value;
    const year = yearSelect.value;
    const engine = engineSelect.value;

    if (!make) {
      alert('Please select at least a vehicle Make to search.');
      return;
    }

    const vehicleObj = { make, model, year, engine };
    try { localStorage.setItem('partsbook_selected_vehicle', JSON.stringify(vehicleObj)); } catch {}

    // Construct search URL
    const engineCode = engine.match(/\(([^)]+)\)/)?.[1] || '';
    const searchTerms = [make, model, engineCode].filter(Boolean).join(' ');
    window.location.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(searchTerms)}&type=product`;
  });
});
